/*
 * @Descripttion: 
 * @version: 
 * @Author: hanzb
 * @Date: 2020-02-13 10:09:18
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-24 13:47:16
 */
// import G6 from '@antv/g6';//G6使用外部文件
import React from 'react';
import { uuidDate } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import SgiCtlComponent from '../sgiBaseComp/SgiCtlComponent';
import { getConstByKey } from '../sgiBaseComp/SgiCommon';

export default class SgiG6Component extends SgiCtlComponent {

	constructor(props) {
		super(props);
		let divId = uuidDate(6, "yyyyMMddhhmmssSSS");
		this.state = {
			...this.state,
			divId,
			data: this.props.data,
			options: {},
		};
	}

	// 转换自身属性
	__AddAttribute() {
		let { parentModule, moduleDesc, objFct, type } = this.props;

		if (!moduleDesc) return;

		this.state.divId = getConstByKey(this, moduleDesc.cId) || this.state.divId || uuidDate(6, "yyyyMMddhhmmssSSS");

		// 取data
		const bdInst = getConstByKey(this, moduleDesc.bdInst);
		this.state.insName = bdInst;
		if (bdInst && objFct) this.state.data = objFct.get(bdInst);

	}

	// 渲染
	__render = () => <div id={this.state.divId} {...this.state._props} />

	refreshByData(data) {
		this.state.data = data;
		this.state.graph.read(data || {});
	}

	refresh = () => {
		let bdInst = this.state.insName;
		let objFct = this.props.objFct;
		let data = (bdInst && objFct) ? objFct.get(bdInst) : null;
		this.refreshByData(data);
	}

	__componentDidMount() {
		let options = this.state.options || {};
		if (!options.container) options.container = this.state.divId;
		if (!options.width) options.width = document.getElementById(this.state.divId).scrollWidth;
		if (!options.height) options.height = document.getElementById(this.state.divId).scrollHeight || 500;
		let graph = new G6.Graph(Object.assign(options));
		let data = this.state.data;
		graph.data(data || {});
		graph.render();
		this.state.graph = graph;
	}

	__componentWillMount() {
		let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
		let { _props, _class, options, insName, inOutType } = this.state;
		let { functions } = this.data;

		if (!moduleDesc || !objFct) return;

		if (this.props.type != 'dnd') {
			try {
				let initFn;
				if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initLsn"]) {
					// 事件集模式
					let funs = Object.assign({}, objFct.get("@funs"), this.funs);
					let key = moduleDesc.eventKeys["initLsn"];
					initFn = funs[key];
				} else {
					// 原事件模式
					var initLsn = moduleDesc.initLsn;// 页面初始化监听器
					initFn = new Function("module", "objFct", "G6", "containerId", initLsn);
				}
				// var initFn = new Function("module", "objFct", initLsn);
				if (initFn && typeof initFn === "function") initFn(this, objFct, G6, this.state.divId);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
		}
	}
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiG6/SgiG6Component.js